import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const CARDS = [
  {
    icon: 'fa-bolt',
    title: 'Instant Results',
    desc: 'Get a complete quantum security assessment for any public domain in under 10 seconds — no installation, no API keys, no waiting.',
  },
  {
    icon: 'fa-shield',
    title: 'NIST PQC Aligned',
    desc: 'Our vulnerability checks and remediation advice follow the NIST Post-Quantum Cryptography standards published in 2024 (FIPS 203/204/205).',
  },
  {
    icon: 'fa-file-pdf-o',
    title: 'Professional Reports',
    desc: 'Download a branded PDF report or email it directly to your CISO, security team, or compliance officer with a single click.',
  },
  {
    icon: 'fa-lock',
    title: 'Zero Data Retained',
    desc: 'We perform a live read-only TLS handshake. No domain data, certificate content, or personal information is stored on our servers.',
  },
  {
    icon: 'fa-graduation-cap',
    title: 'Educational Context',
    desc: 'Every result comes with plain-English explanations so non-technical stakeholders can understand quantum risk without a cryptography degree.',
  },
  {
    icon: 'fa-users',
    title: 'Expert Consultation',
    desc: 'Need a full quantum-readiness audit across your infrastructure? Our team provides hands-on PQC migration consulting and certificate uplift services.',
  },
];

const QuantomeServices = () => {
  useEffect(() => { AOS.init({ duration: 1000 }); }, []);

  return (
    <div style={S.section}>
      <div style={S.container}>

        {/* heading */}
        <div style={S.titleWrap} data-aos="fade-up">
          <h2 style={S.title}>Why Choose Quantum Shield?</h2>
          <p style={S.subtitle}>
            The fastest, most actionable quantum-readiness check available — free, open, and built by
            RedRuby's security engineers.
          </p>
        </div>

        {/* 3-column grid */}
        <div style={S.grid} className="qsvc-grid" data-aos="fade-up">
          {CARDS.map(({ icon, title, desc }, i) => (
            <div key={title} style={S.card}>
              <div style={S.iconCircle}>
                <i className={`fa ${icon}`} style={S.icon} />
              </div>
              <h3 style={S.cardTitle}>{title}</h3>
              <p style={S.cardDesc}>{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const S = {
  section: {
    padding: '80px 20px',
    background: '#f8fafc',
    overflow: 'hidden',
  },
  container: {
    maxWidth: 1100,
    margin: '0 auto',
  },
  titleWrap: {
    textAlign: 'center',
    marginBottom: 48,
  },
  title: {
    fontSize: 'clamp(24px,3vw,34px)',
    fontWeight: 800,
    color: '#0f172a',
    margin: '0 0 12px',
  },
  subtitle: {
    color: '#64748b',
    fontSize: 16,
    margin: '0 auto',
    maxWidth: 560,
    lineHeight: 1.6,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 24,
  },
  card: {
    background: '#fff',
    border: '1px solid #e2e8f0',
    borderRadius: 16,
    padding: '28px 24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
  },
  iconCircle: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    background: '#eff6ff',
    border: '1.5px solid #bfdbfe',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 16,
    flexShrink: 0,
  },
  icon: {
    fontSize: 20,
    color: '#1e40af',
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: 700,
    color: '#1e293b',
    margin: '0 0 8px',
    lineHeight: 1.3,
  },
  cardDesc: {
    fontSize: 13.5,
    color: '#64748b',
    lineHeight: 1.65,
    margin: 0,
  },
};

export default QuantomeServices;
